import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { API_BASE_URL } from '../config/api';

type ContactMessage = {
  Id: number;
  Name: string;
  Email: string;
  Phone?: string;
  Company?: string;
  Message: string;
  CreatedAt: string;
};

export default function ContactMessagesPage() {
  const { t } = useTranslation();
  const [messages, setMessages] = useState<ContactMessage[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetch(`${API_BASE_URL}/contact`)
      .then(res => {
        if (!res.ok) throw new Error('Failed to fetch messages');
        return res.json();
      })
      .then(setMessages)
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">{t('admin:contactMessages', 'Contact Messages')}</h1>
      {loading && <div>{t('admin:loading', 'Loading...')}</div>}
      {error && <div className="text-red-600">{error}</div>}
      {!loading && !error && (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border border-slate-200 rounded-lg">
            <thead>
              <tr>
                <th className="p-2 border-b">#</th>
                <th className="p-2 border-b">{t('admin:name', 'Name')}</th>
                <th className="p-2 border-b">{t('admin:email', 'Email')}</th>
                <th className="p-2 border-b">{t('admin:phone', 'Phone')}</th>
                <th className="p-2 border-b">{t('admin:company', 'Company')}</th>
                <th className="p-2 border-b">{t('admin:message', 'Message')}</th>
                <th className="p-2 border-b">{t('admin:date', 'Date')}</th>
              </tr>
            </thead>
            <tbody>
              {messages.map((msg) => (
                <tr key={msg.Id} className="hover:bg-slate-100">
                  <td className="p-2 border-b">{msg.Id}</td>
                  <td className="p-2 border-b">{msg.Name}</td>
                  <td className="p-2 border-b">{msg.Email}</td>
                  <td className="p-2 border-b">{msg.Phone || '-'}</td>
                  <td className="p-2 border-b">{msg.Company || '-'}</td>
                  <td className="p-2 border-b">{msg.Message}</td>
                  <td className="p-2 border-b">{new Date(msg.CreatedAt).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
